import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { OrganizationService } from '../organization.service';
import { Organization } from '../organization.model';

@Component({
  selector: 'app-organization-edit',
  templateUrl: './organization-edit.component.html',
  styleUrls: ['./organization-edit.component.scss']
})
export class OrganizationEditComponent implements OnInit {

  public organizationId: number;
  public organization: Organization;
  public logo;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.org_id) {
        this.organizationId = params.org_id;
        this.organization = this.organizationService.organization(this.organizationId);
        if (!this.organization) {
          this.router.navigate(['../organizations']);
        } else {
          this.organizationService.getOrgUsers(this.organization.id);
        }
      } else {
        this.router.navigate(['../organizations']);
      }
    })
  }

  submitForm() {
    let data = {...this.organization}
    if (this.logo) data.logo = this.logo;
    if (this.organizationId) {
      this.organizationService.updateOrg(data)
        .subscribe((res) => {
          console.log(res)
          this.router.navigate(['../organizations'])
        })
    } else {
      this.organizationService.createOrg(data)
        .subscribe((res) => {
          console.log(res)
          this.router.navigate(['../organizations'])
        })
    }
  }

  uploadLogo($event) {
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.logo = myReader.result;
    }
    myReader.readAsDataURL(file);
  }

}
